import { ContainedButton } from '../../../components/buttons';
import { useConfiguratorDispatch, useRootSelector } from '../../../store';
import {
  configureAnother,
  selectIsAtConfigCap,
  selectMaxConfigs
} from '../store/multiConfigSlice';

export function ConfigureAnotherButton() {
  const dispatch = useConfiguratorDispatch();
  const isAtCap = useRootSelector(selectIsAtConfigCap);
  const maxConfigs = useRootSelector(selectMaxConfigs);

  if (isAtCap) {
    return (
      <p className="mt-2 text-sm text-gray-500">
        You&apos;ve reached the maximum of {maxConfigs} configurations.
      </p>
    );
  }

  return (
    <ContainedButton
      size="large"
      color="secondary"
      className="mt-3"
      style={{ border: '1px solid currentColor' }}
      onClick={() => dispatch(configureAnother())}
      data-testid="configure-another-button"
    >
      Configure Another
    </ContainedButton>
  );
}
